import { TextObjectKinds } from "../../../../../../../documaker/domain/format/objects";
import { ITextObjectBean } from "../../../beans/objects";

export class TextObjectKindTranslator {
  from(bean: ITextObjectBean): TextObjectKinds {
    if (bean["@source-file"] !== undefined) { // 新規オブジェクトについては空文字列でも許容するので属性があるかで判定.
      return TextObjectKinds.UserDefined;
    } else if (bean["@name"] && (0 < bean["@name"].length)) {
      if (/graph_[0-9]+\[[1-4]\]/.test(bean["@name"])) {
        return TextObjectKinds.RangeOfMotion;
      }
      return (bean["@name"] === "指定医番号") 
        ? TextObjectKinds.DesignatedDoctorNumber
        : TextObjectKinds.HisItem;
    } else if (bean["@type"] === "1") { 
      return (bean["@input-code"] && (bean["@input-code"] === "1"))
        ? TextObjectKinds.Number
        : TextObjectKinds.Fixed;
    } else {
      return TextObjectKinds.Free;
    }
  }

  // toは不要.(他の属性変換でケアされるので.)
}
